export default {
  IS_COOKIE_BANNER_ENABLED: 'isCookieBannerEnabled',
  BUSINESS_NAME: 'businessName',
  PHONES: 'phones',
  ADDRESSES: 'addresses',
  EMAILS: 'emails',
  BUSINESS_HOURS: 'businessHours',
};
